import GateLayoutComponent from '../components/GateLayout/GateLayout';

export default GateLayoutComponent;
